import api from "./api";

/**
 * System audit service (SUPER_ADMIN only)
 * Endpoints:
 * - GET /system-audit                 → system-wide counts + total AI tokens
 * - GET /system-audit/ai-usage        → AI usage records (company_id, user_id, from_date, to_date)
 * - GET /system-audit/ai-usage/weekly → token totals per day for the last 7 days (company_id, user_id)
 */

const toQuery = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  ).toString();
  return query ? `?${query}` : "";
};

export async function getSystemOverview() {
  const res = await api.get("/system-audit");
  return {
    companies: Number(res?.companys) || 0, // API spells it "companys"
    users: Number(res?.users) || 0,
    jobs: Number(res?.jobs) || 0,
    jobPaeis: Number(res?.jobPaeis) || 0,
    aiTokens: Number(res?.aiUsages) || 0, // token total, not a record count
  };
}

export async function getAiUsage({ companyId, userId, fromDate, toDate } = {}) {
  const res = await api.get(
    `/system-audit/ai-usage${toQuery({
      company_id: companyId,
      user_id: userId,
      from_date: fromDate,
      to_date: toDate,
    })}`,
  );
  return {
    totalTokens: Number(res?.total_tokens) || 0,
    records: Array.isArray(res?.data) ? res.data : [],
  };
}

export async function getWeeklyAiUsage({ companyId, userId } = {}) {
  const res = await api.get(
    `/system-audit/ai-usage/weekly${toQuery({ company_id: companyId, user_id: userId })}`,
  );
  return Array.isArray(res) ? res : [];
}
